import { createSlice } from '@reduxjs/toolkit'
import { COMPANIES } from '../../utils/constants/actionTypes'
import createAsyncThunkMiddleware from '../../utils/helpers/createAsyncThunkMiddleware'
import CompaniesServices from './companies.service'
import extraReducersCommon from '../common/extraReducers'

/**
 * body - {...}
 */
export const createCompany = createAsyncThunkMiddleware(
  COMPANIES.CREATE,
  CompaniesServices.create,
)

/**
 * filter, limit, page
 */
export const getAllCompanies = createAsyncThunkMiddleware(
  COMPANIES.GET_ALL,
  CompaniesServices.getAll,
)

/**
 * { userId, body - {...}}
 */
export const updateCompany = createAsyncThunkMiddleware(
  COMPANIES.UPDATE,
  CompaniesServices.update,
)

/**
 * roleId
 */
export const removeCompany = createAsyncThunkMiddleware(
  COMPANIES.REMOVE,
  CompaniesServices.remove,
)

const initialState = []

const companies = createSlice({
  name: 'companies',
  initialState,
  reducers: {},
  extraReducers: extraReducersCommon(
    createCompany,
    updateCompany,
    getAllCompanies,
    removeCompany,
  ),
})

export default companies.reducer
